import { first, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from './permission.service';
import { TenantService } from './tenant.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class PartnerRoleGuard implements CanActivate {
    constructor(private permissionService: PermissionService, 
                private tenantService: TenantService,
                private userService: UserService) { }

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return this.userService.isLoggedIn()
        .pipe(
            map(response => {
                if(!response.user){
                    return true;
                }
                const hasPermission = this.permissionService.userHasPermission(response.user, {action: 'CREATE_TENANTS'}); 
                if(!hasPermission){
                    this.tenantService.getUnauthTenantInfo().pipe(first()).subscribe(tenant =>
                        window.location.href = this.permissionService.userHasPermission(response.user, {action: 'MANAGE_TENANT'}) ? 
                            tenant.settings.defaultPages.TENANT_ADMIN || tenant.settings.defaultPages.DEFAULT || '/client' : 
                            tenant.settings.defaultPages.DEFAULT || '/client'
                    );
                }
                return hasPermission;
            })
        );
    };
}
